export default {
  common: {
    title: 'AI智能助手',
    快捷功能: '快捷功能',
    为您推荐: '为您推荐',
    内容声明: '内容由AI生成，仅供参考',
    思考中: '思考中',
    取消: '取消',
    保存: '保存',
    确定: '确定',
    新会话: '新会话',
    开始新会话: '开始新会话',
    加载中: '加载中...',
    登录中: '登录中...',
    保存中: '保存中...',
    保存成功: '保存成功',
    保存失败: '保存失败',
  },
  card: {
    优选: '优选',
    展商: '展商',
    展品: '展品',
    会议: '会议',
    活动: '活动',
    商机: '商机',
    广告: '广告',
    会议活动: '会议&活动',
    AI推荐: 'AI推荐',
    展位号: '展位号：',
  },
  message: {
    说话时间太短: '说话时间太短',
    没有听到说话: '没有听到说话',
    即将结束: '{s}s后将停止录音',
    没有更多了: '没有更多了',
    暂无会话记录: '暂无会话记录',
    链接已复制: '链接已复制，请在浏览器中打开',
    链接复制失败: '链接复制失败',
    邮箱已复制: '邮箱已复制',
    邮箱复制失败: '邮箱复制失败',
  },
  agent: {
    按住说话: '按住说话',
    录音中: '录音中...',
    松手取消发送: '松手取消发送',
    松开发送上滑取消: '松开发送 上滑取消',
    正在识别中: '正在识别中',
    已思考: '已思考',
    思考中: '思考中',
    用时: '（用时{s}秒）',
    默认占位符: '发消息',
  },
  operation: {
    编辑: '编辑对话名称',
    删除: '从对话列表删除',
  },
  title: {
    重命名会话: '重命名会话',
    会话记录: '会话记录',
    今天: '今天',
    昨天: '昨天',
    三天内: '三天内',
    七天内: '七天内',
    更早: '更早',
  },
  placeholder: {
    请输入会话名称: '请输入会话名称',
  },
  error: {
    暂无权限: '暂无权限',
    暂无权限提示: '您暂无权限访问该页面',
    暂无配置: '暂无配置',
    暂无配置提示: '未获取到页面配置信息，请确认访问权限',
    服务异常: '服务异常',
    网络异常: '网络异常',
    未知错误: '未知错误',
    未知错误提示: '发生未知错误，请稍后重试',
    页面不存在: '页面不存在',
    页面不存在提示: '您访问的页面不存在或已被移除',
    服务异常提示: '服务器响应异常，请稍后重试',
    重试: '重试',
    返回: '返回',
    正在重试: '正在重试...',
  },
  webview: {
    重新加载: '重新加载',
    加载超时: '加载超时，请检查网络',
    页面加载失败: '页面加载失败',
    页面加载中: '页面加载中',
  },
  route: {
    展商地图: '展商地图',
    详情: '详情',
    小助手设定: '小助手设定',
  },
  map: {
    标题: '提示',
    提示: '是否进入展位导航?',
    确认: '进入',
    取消: '取消',
  },
  detailsPage: {
    基本信息: '基本信息',
    展商简介: '展商简介',
    产品简介: '产品简介',
    展品列表: '展品列表',
    更多展品推荐: '更多展品推荐',
    注册资金: '注册资金:',
    成立时间: '成立时间:',
    注册地址: '注册地址:',
    食品类型: '食品类型:',
    出口区域: '出口区域:',
    产品分类: '产品分类:',
    所在地: '所在地:',
    详情: '详情',
    展位号: '展位号:',
    时间: '时间:',
    地点: '地点:',
    当前: '当前',
    暂无展品数据: '暂无展品数据',
  },
  settings: {
    基础设定: '基础设定',
    角色与风格: '角色与风格',
    助手角色: '助手角色',
    对话风格: '对话风格',
    特殊要求: '特殊要求',
    其他设置: '其他设置',
    保存设置: '保存设置',
    深度思考: '深度思考',
    语言设置: '多语言',
    助手名称: '助手名称',
    请输入: '请输入',
  },
  enum: {
    role: {
      professionalAdviser: '专业观展顾问',
      industryExpert: '行业专家',
      exhibitionNavigator: '展会领航员',
      caringAssistant: '贴心小助手'
    },
    style: {
      enthusiastic: '热情详细',
      concise: '简洁专业',
      humorous: '幽默风趣',
      rigorous: '严谨认真'
    }
  }
}
